import { createRouter } from '@tanstack/react-router'

import { routeTree } from '@/app/router/route-tree.gen'
import { queryClient } from '@/shared/lib/query'

export type RootRouteContext = {
  queryClient: typeof queryClient
}

export const router = createRouter({
  routeTree,
  context: {
    queryClient,
  },
  defaultPreload: 'intent',
  defaultPreloadStaleTime: 0,
  trailingSlash: 'preserve',
})

//! This declaration is needed to make the router available for type suggestions in the app
declare module '@tanstack/react-router' {
  interface Register {
    router: typeof router
  }
}
